export default function SolidArrow() {
  return (
    <>
      <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.795 9.16854L0 8.37354L3.7275 4.64604L0 0.918535L0.795 0.123535L5.3175 4.64604L0.795 9.16854Z" fill="#007383" />
      </svg>
    </>
  );
}
